import { Chip, Tooltip } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { REFUND_METHOD, isReturnedTransactionStatus } from '@/utility';

const AchReturnedChip = (props) => {
  const { t } = useTranslation();

  if (
    props.payment.refund_method !== REFUND_METHOD.ACH ||
    !isReturnedTransactionStatus(props.payment.transaction_status)
  ) {
    return null;
  }

  if (!props.payment?.source_ach_details?.return?.code) {
    return (
      <Chip
        size='small'
        variant='filled'
        color='error'
        label={t('payments.chipLabels.returned')}
      />
    );
  }

  return (
    <>
      <Tooltip
        placement='top'
        title={`${props.payment?.source_ach_details?.return?.code} - ${props.payment?.source_ach_details?.return?.reason}`}>
        <Chip
          size='small'
          variant='filled'
          color='error'
          label={t('payments.chipLabels.returned')}
          clickable
          onDelete={() => {}}
          deleteIcon={<HelpIcon />}
        />
      </Tooltip>
    </>
  );
};

export default AchReturnedChip;
